<template>
    <div>
        <loading
            :active.sync="isLoading"
            :can-cancel="false"
            loader="dots"
            :is-full-page="fullPage"
            :height="height"
            :width="width"
            background-color="#6b6969"
        ></loading>
        <div class="login-page">
            <div class="login-logo">
                <div><img src="../../../public/assets/img/gtl_white.png" alt="" style="width: 100px;"
                          class="img-fluid mb-3"></div>
                <router-link to="/" class="text-light"><b>Company Login</b></router-link>
            </div>
            <div style="width: 360px;">
                <div class="card" style="margin-top: 0px">
                    <div class="card-body login-card-body">
                        <router-link to="/"><div class="login-box-msg"><i class="fas fa-home"></i> Go to Home</div></router-link>
                        <p class="login-box-msg">Sign in to start your session</p>
                        <form @submit.prevent="login">
                            <div class="input-group mb-3">
                                <input type="email" placeholder="email" required class="form-control"
                                       v-model="data.email"/>
                                <div class="input-group-append">
                                    <div class="input-group-text">
                                        <span class="fas fa-envelope"></span>
                                    </div>
                                </div>
                            </div>
                            <div class="input-group mb-3">
                                <input :type="passwordFieldType" placeholder="password" required v-model="data.password"
                                       class="form-control"/>
                                <div class="input-group-append" @click="switchVisibility">
                                    <div class="input-group-text">
                                        <span class="fas fa-lock"></span>
                                    </div>
                                </div>
                            </div>
                            <p><router-link to="/register">Dont have an account? Register</router-link> </p>
                            <div class="row">
                                <div class="col-md-6 offset-md-3">
                                    <button type="submit" class="btn btn-primary btn-block">Sign In</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    /* eslint-disable */
    import $ from 'jquery';
    import Swal from "sweetalert2";
    import "vue-loading-overlay/dist/vue-loading.css";

    export default {
        name: "Login",
        data() {
            return {
                isLoading: false,
                fullPage: true,
                height: 128,
                width: 128,
                data: {
                    email: '',
                    password: ''
                },
                passwordFieldType: "password"

            };
        },
        components: {
            Sidebar: () => import('@/components/Sidebar'),
            Topnav: () => import('@/components/Topnav'),
            Loading: () => import('vue-loading-overlay'),
        },
        methods: {
            switchVisibility() {
                this.passwordFieldType =
                    this.passwordFieldType === "password" ? "text" : "password";
            },
            login() {
                this.isLoading = true;
                this.$store
                    .dispatch("companyLogin", this.data)
                    .then(() => {
                        if (this.$store.state.redirectPathLink !== null) {
                            this.$router.push((this.$store.state.redirectPathLink.path.fullPath));
                        } else {
                            this.$router.push('/company/dashboard');
                        }
                    })
                    .catch((err) => {
                        console.clear();
                        if (!(((err.response || {}).data || {}).success)) {
                            console.log(err.response)
                            Swal.fire({
                                title: "Error!",
                                text: err.response.data.message,
                                icon: "error",
                                confirmButtonText: "OK"
                            });
                        } else {
                            Swal.fire({
                                title: "Error!",
                                text: "Error whiles processing information",
                                icon: "error",
                                confirmButtonText: "OK"
                            });
                        }

                    }).finally(() => {
                    this.isLoading = false;
                });
            },

        },
        created() {
            setTimeout(() => {
                $('.nav-router-link').removeClass('active')
                $('#hub').addClass('active')
            }, 500)
        }
    };
</script>

<style scoped src="../../../public/assets/css/intern-dashboard.css" />

<style scoped>
    .login-page {
        background-image: url('../../assets/company.jpeg');
        background-size: cover;
        background-position: center center;
    }
</style>
